import {Component} from '@angular/core';
import {ComponentBase} from '@drl/core/component-base';
import {IpsTranslateService} from '@drl/core/localization/ips-translate.service';
import {TranslateService} from '@ngx-translate/core';
import {NbDialogRef, NbDialogService} from '@nebular/theme';
import {csvTypeMap, CsvType} from '@drl/shared/utility/csv-type.utility';
import {map} from 'lodash-es';
import {BulkEhrDataFacadeService} from '@drl/shared/facades/bulk-ehr-data-facade.service';
import {ToastrService} from 'ngx-toastr';
import {SystemStoreFacadeService} from '@drl/core/store/system-store-facade.service';
import {environment} from '@drl/env/environment';
import {BulkUploadResultComponent} from '../bulk-upload-result/bulk-upload-result.component';

@Component({
  selector: 'app-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss'],
})
export class BulkUploadComponent extends ComponentBase {
  constructor(
    protected readonly translateSvc: IpsTranslateService,
    protected dialogRef: NbDialogRef<BulkUploadComponent>,
    private readonly bulkEhrFacade: BulkEhrDataFacadeService,
    private readonly toastrService: ToastrService,
    private readonly systemStoreFacade: SystemStoreFacadeService,
    protected readonly dialogService: NbDialogService,
  ) {
    super();
    this.translate = this.translateSvc.translate;
  }

  loading = false;
  translate: TranslateService;
  selectedDocType: string;
  csvData: File;
  csvName: string;
  uploadSuccessMsg: string;
  successLbl: string;
  selectedAssetUrl: string;
  invalidFile: string;
  sampleFileDownloadToolTip: string;
  selectCatToDownload: string;
  locale: string;
  docTypes: {
    label: string;
    value: CsvType;
    url: string;
  }[];
  errorLbl: string;
  errorMsgLbl: string;
  closeOnBackDropClick: boolean;

  ngOnInit() {
    this.getTranslations();
    this.csvName = this.translateSvc.translate.instant('chooseFileLbl');
    this.systemStoreFacade.getLocale().subscribe(locale => {
      this.locale = locale;
      this.docTypes = map(
        csvTypeMap(this.translateSvc.translate, this.locale),
        (cat, key) => {
          return {
            label: cat.name,
            value: cat.key,
            url: cat.url,
          };
        },
      );
    });
  }

  downloadAsset(event) {
    if (!this.selectedAssetUrl) {
      event.preventDefault();
    }
  }

  setDownloadAsset(event) {
    const asset = this.docTypes.find(item => item.value === event.value);
    if (asset) {
      this.selectedAssetUrl = asset.url;
    } else {
      this.toastrService.error(this.invalidFile, 'ERROR !', {
        timeOut: environment.messageTimeout,
      });
    }
  }

  getTranslations() {
    this.translate
      .get([
        'uploadSuccessMsg',
        'successLbl',
        'sampleFileDownloadToolTip',
        'selectCatToDownload',
        'invalidFile',
        'errorLbl',
        'errorMsgLbl',
      ])
      .subscribe(res => {
        this.uploadSuccessMsg = res.uploadSuccessMsg;
        this.successLbl = res.successLbl;
        this.sampleFileDownloadToolTip = res.sampleFileDownloadToolTip;
        this.selectCatToDownload = res.selectCatToDownload;
        this.invalidFile = res.invalidFile;
        this.errorLbl = res.errorLbl;
        this.errorMsgLbl = res.errorMsgLbl;
      });
  }

  close() {
    this.dialogRef.close();
  }

  uploadDoc(form) {
    if (form.invalid || !this.csvData) {
      return;
    }
    this.loading = true;
    const formData = new FormData();
    formData.append('file', this.csvData);
    formData.append('type', this.selectedDocType);
    const timezoneOffset = new Date().getTimezoneOffset()
    formData.append('timeZoneOffset', JSON.stringify(timezoneOffset))
    this._subscriptions.push(
      this.bulkEhrFacade.uploadCsv(formData).subscribe(
        // sonarignore:start
        (res: any) => {
          // sonarignore:end
          if (res.success) {
            this.closeOnBackDropClick = true;
            this.toastrService.success(this.uploadSuccessMsg, this.successLbl);
          } else {
            this.closeOnBackDropClick = false;
          }
          this.close();
          const context = {
            errReport: res,
          };
          this.dialogService
            .open(BulkUploadResultComponent, {
              closeOnBackdropClick: this.closeOnBackDropClick,
              context,
            })
            .onClose.subscribe();

          this.loading = false;
        },
        err => {
          this.loading = false;
        },
      ),
    );
  }

  fileProgress(event) {
    this.csvData = event.target.files[0] as File;

    this.csvName = this.csvData.name;
  }
}
